import {
  dimensionTypes,
  getDefaultSequence,
  getDefaultSequenceDimensions,
} from '../../constants/retention';

const composeInitialState = {
  firstEvent: null,
  returnEvent: null,
  dimensionType: dimensionTypes.DAILY,
  sql: '',
  error: '',
};

const compose = (state = composeInitialState, action) => {
  switch (action.type) {
    case 'CHANGE_RETENTION_FIRST_EVENT':
      return {
        ...state,
        firstEvent: action.event,
      };

    case 'CHANGE_RETENTION_RETURN_EVENT':
      return {
        ...state,
        returnEvent: action.event,
      };

    case 'CHANGE_RETENTION_DIMENSION_TYPE':
      return {
        ...state,
        dimensionType: action.dimensionType,
        customSequence: getDefaultSequence(state.customSequenceType, action.dimensionType),
        customSequenceDimensions: getDefaultSequenceDimensions(
          state.customSequenceType,
          action.dimensionType
        ),
      };

    case 'EXPOSE_RETENTION_QUERY_SUCCESS':
      return {
        ...state,
        error: '',
        sql: action.sql,
      };

    case 'EXPOSE_RETENTION_QUERY_FAILURE':
      return {
        ...state,
        sql: '',
        error: action.error,
      };

    default:
      return state;
  }
};

export default compose;

export const getFirstEvent = (state) => state.firstEvent;

export const getReturnEvent = (state) => state.returnEvent;

export const getDimensionType = (state) => state.dimensionType;

export const getRetentionSQL = (state) => state.sql;

export const getError = (state) => state.error;
